module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_3009.1b0424d9.png";